import { utils } from 'xlsx';

const translateVehicle = (vehicleType, translate) => {
  if (vehicleType === '0') {
    return translate('repostajes.filtros.vehiculos.turismo');
  }

  if (vehicleType === '1') {
    return translate('repostajes.filtros.vehiculos.moto');
  }

  if (vehicleType === '2') {
    return translate('repostajes.filtros.vehiculos.camion');
  }

  return '-';
};

const translateFuel = (fuel, translate) => {
  if (fuel === 'Gasolina') {
    return translate('datos.modal.editar.form.combustible.gasolina');
  }

  if (fuel === 'Diesel') {
    return translate('datos.modal.editar.form.combustible.diesel');
  }

  return fuel || '-';
};

const translatePaymentMethod = (paymentMethod, translate) => {
  if (paymentMethod === 'Tarjeta') {
    return translate('repostajes.table.pago-tarjeta');
  }

  if (paymentMethod === 'Efectivo') {
    return translate('repostajes.table.pago-efectivo');
  }

  if (paymentMethod === '' || paymentMethod === 'Petroprix') {
    return translate('repostajes.table.pago-bonusprix');
  }

  return paymentMethod || '-';
};

const formatStation = ({ nombre, direccion, cp }) => {
  const address = [direccion, cp].filter(Boolean).join(' ');
  return [nombre, address].filter(Boolean).join('\n') || '-';
};

export const buildRefuellingExport = (data, translate) => {
  const headers = [
    translate('repostajes.table.fecha'),
    translate('repostajes.table.matricula'),
    translate('repostajes.table.vehiculo'),
    translate('repostajes.table.combustible'),
    translate('repostajes.table.litros'),
    translate('repostajes.table.precio'),
    translate('repostajes.table.tipo-pago'),
    translate('repostajes.table.gasolinera'),
  ];

  const rows = data.map((refuelling) => [
    refuelling.fecha,
    refuelling.matricula || '-',
    translateVehicle(refuelling.tipo_vehiculo, translate),
    translateFuel(refuelling.combustible, translate),
    refuelling.litros,
    refuelling.importe_cob,
    translatePaymentMethod(refuelling.tipo_pago, translate),
    formatStation(refuelling),
  ]);

  return { headers, rows };
};

export const buildRefuellingCsv = (data, translate) => {
  const { headers, rows } = buildRefuellingExport(data, translate);
  const worksheet = utils.aoa_to_sheet([headers, ...rows]);
  const csv = utils.sheet_to_csv(worksheet, {
    FS: ';',
  });

  return `\uFEFF${csv}`;
};
